export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0">
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-3xl bg-primary-500 flex items-center justify-center">
              <span className="font-heading text-3xl md:text-4xl font-black text-background-50">UU</span>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-4">
              关于UU漫画
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              UU漫画诞生于漫迷社区，由一群热爱连载漫画的追更人共同打造。我们深知追更漫画时错过更新的焦虑，
              因此专注于漫画追更服务，致力于为每一位漫迷提供最新漫画更新的追踪与提醒。
              平台收录超过12,000部免费漫画全集，覆盖30余个漫画品类，每日同步更新数百部连载漫画的最新章节。
              无论是热血激斗、甜蜜恋爱还是烧脑悬疑，UU漫画都是你追漫必备的漫画更新提醒伙伴。
              不再错过任何一话，追更漫画就上UU漫画。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}